import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import apiLoginService from '../services/apiLoginService'
import '../styles/FormView.css'
import UsersListCard from '../components/users/UsersListCard'

function UsersView() {
  const navigate = useNavigate()
  const role = (sessionStorage.getItem('role') || '').toUpperCase()
  const isAdmin = role === 'ADMIN'
  const [users, setUsers] = useState([])
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [totalElements, setTotalElements] = useState(0)
  const [isLoadingUsers, setIsLoadingUsers] = useState(false)
  const [usersError, setUsersError] = useState('')
  const loadUsers = async (nextPage = page, nextSize = size) => {
    setIsLoadingUsers(true)
    setUsersError('')
    try {
      const data = await apiLoginService.getUsers(nextPage, nextSize)
      const pageInfo = data?.page || {}
      setUsers(Array.isArray(data?.content) ? data.content : [])
      setPage(typeof pageInfo?.number === 'number' ? pageInfo.number : nextPage)
      setSize(typeof pageInfo?.size === 'number' ? pageInfo.size : nextSize)
      setTotalPages(typeof pageInfo?.totalPages === 'number' ? pageInfo.totalPages : 0)
      setTotalElements(typeof pageInfo?.totalElements === 'number' ? pageInfo.totalElements : 0)
    } catch (error) {
      const message = error?.body?.message || 'No se pudieron cargar los usuarios.'
      setUsersError(message)
    } finally {
      setIsLoadingUsers(false)
    }
  }

  useEffect(() => {
    loadUsers(0, size)
  }, [size])

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Users</h1>
          </div>
          <Row className="justify-content-center mt-4">
            <Col xs={12} lg={10}>
              <div className="d-flex justify-content-end mb-3">
                <Button color="success" onClick={() => navigate('/users/add')}>
                  Añadir usuario
                </Button>
              </div>
              <UsersListCard
                users={users}
                isLoadingUsers={isLoadingUsers}
                usersError={usersError}
                onRefresh={() => loadUsers(page, size)}
                onEdit={(user) => navigate(`/users/edit/${user.id}`, { state: { user } })}
                canEdit={isAdmin}
                page={page}
                totalPages={totalPages}
                totalElements={totalElements}
                size={size}
                onPageChange={(nextPage) => loadUsers(nextPage, size)}
                onSizeChange={(nextSize) => setSize(nextSize)}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default UsersView
